import { useEffect, useState } from 'react';
import { pollAnalysis } from './ai-analysis.js';
import './ai-analysis.css';

export function AiAnalysis({ endpoint }) {
  const [analysis, setAnalysis] = useState(null);
  useEffect(() => {
    setAnalysis(null);
    if (endpoint) return pollAnalysis(endpoint, setAnalysis);
  }, [endpoint]);
  const stale = analysis && (analysis.stale || Date.now() - analysis.sourceReceivedAt > 300000);
  return <section className="ai-analysis panel" aria-label="Analisi AI">
    <header className="ai-analysis-heading"><h2>Analisi AI</h2><span>AI-GENERATED · ADVISORY ONLY</span></header>
    {!analysis ? <p className="ai-analysis-empty">Analisi AI assente</p> : <>
      <div className="ai-analysis-meta">
        <span>Updated <time dateTime={new Date(analysis.generatedAt).toISOString()}>{new Date(analysis.generatedAt).toLocaleString()}</time></span>
        {analysis.model && <span>{analysis.model}</span>}
        {analysis.sampleCount && <span>{analysis.sampleCount} samples</span>}
        {stale && <strong>STALE ANALYSIS</strong>}
      </div>
      <p className="ai-analysis-summary">{analysis.summary}</p>
      <details><summary>Analysis limitations</summary><p>{analysis.limitations}</p></details>
      <p className="ai-analysis-disclaimer">AI interpretation, not device telemetry or an operational alarm. Verify conclusions before taking action.</p>
    </>}
  </section>;
}
